import { useActionCreators, useAppSelector } from 'shared/hooks'
import { StackIcon } from 'shared/ui/StackIcon/StackIcon'

import { actions, selectors } from '../../slice'
import css from './style.module.css'

export function Default() {
	const message = useAppSelector(selectors.message)
	const { resetSnack } = useActionCreators(actions)

	return (
		<div className='snackbar-notification__message'>
			<span className={css.iconWrap}>
				<StackIcon className={css.icon} icon='info' width={18} />
			</span>

			<div className='snackbar-notification__body'>
				<div className='snackbar-notification__title'>
					<span>{message.title}</span>
					<div
						className='snackbar-notification__icon-close'
						onClick={() => resetSnack()}
					/>
				</div>
				<div
					className='snackbar-notification__text'
					dangerouslySetInnerHTML={{ __html: message.content }}
				/>
				{message.button && (
					<div className='notification-button'>
						<a
							className='btn'
							href={message.button.link}
							rel='noopener noreferrer'
							target='_blank'
						>
							{message.button.title}
						</a>
					</div>
				)}
			</div>
		</div>
	)
}
